import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Col,
    Container,
    Row
} from 'reactstrap';

import {fetchGuarantor} from "./actions/guarantor";
import {setNavbarVisibility, setFooterVisibility} from "../navigation/actions/navbar";

import CompleteFrame from './frames/CompleteFrame';
import ConfirmFrame from './frames/ConfirmFrame';
import GuarantorCreditFrame from './frames/GuarantorCreditFrame';
import IntroFrame from './frames/IntroFrame';

import Logo from '../../assets/svg/logo-blue.svg';
import PolyFlowContainer from "../../components/flow/PolyFlow/PolyFlowContainer";
import PolyFlowNavigator from "../../components/flow/PolyFlow/PolyFlowNavigator";
import PolyFlowNavItem from "../../components/flow/PolyFlow/PolyFlowNavItem";
import Loader from "../../components/display/Loader";

class GuarantorContainer extends Component {
    componentWillMount() {
        this.props.onLoad();
    }

    content = () => {
        const {guarantor_confirmed, guarantor_verified} = this.props;

        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <img style={{maxWidth: '100px', margin: '-1rem'}} src={Logo} alt="PolyRents"/>
                </div>

                <PolyFlowNavigator id="guarantorFlow">
                    <PolyFlowNavItem filled label="Getting Started"/>
                    <PolyFlowNavItem filled={guarantor_confirmed} label="Confirm Info"/>
                    <PolyFlowNavItem filled={guarantor_verified} disabled={!guarantor_confirmed} label="Credit Check"/>
                    <PolyFlowNavItem filled={guarantor_verified} disabled={!guarantor_verified} label="Complete"/>
                </PolyFlowNavigator>
                <Container>
                    <Row>
                        <Col md={12}>
                            <PolyFlowContainer id="guarantorFlow" props={{tenant_id: this.props.params.tenant_id, tenant_key: this.props.params.key}}>
                                <IntroFrame/>
                                <ConfirmFrame/>
                                <GuarantorCreditFrame/>
                                <CompleteFrame/>
                            </PolyFlowContainer>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    };

    render() {
        return this.props.guarantor_name ? this.content() : <Loader spin isLoading/>;
    }
}

const mapStateToProps = (state) => ({
    guarantor_name: state.guarantor.first_name,
    guarantor_confirmed: state.guarantor.confirmed,
    guarantor_verified: state.guarantor.verification_status === 'Verified'
});

const mapDispatchToProps = (dispatch, props) => ({
    onLoad() {
        dispatch(setNavbarVisibility(false));
        dispatch(setFooterVisibility(false));
        return dispatch(fetchGuarantor(props.params.tenant_id, props.params.key));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(GuarantorContainer);


// WEBPACK FOOTER //
// ./src/containers/guarantor/GuarantorContainer.js